<!--
 * @Author: ZhengXiaowei
 * @Date: 2019-02-21 11:54:38
 * @LastEditors: 晓晓晓晓晓丶vv
 * @LastEditTime: 2020-04-30 10:01:26
 * @Description: 首页
 -->
<template>
  <div class="x-home">
    <template v-if="!init">
      <x-skeleton-home />
    </template>
    <template v-else>
      <div class="x-book__city" v-if="init">
        <div class="x-city__header van-hairline--bottom" v-if="!isApp">
          <img
            src="https://cdn.ycsd.cn/ycsd_web_3nd/images/logo.png"
            alt=""
            class="x-city__logo"
          />
          <div class="x-city__search">
            <input
              class="x-city__search--input"
              type="text"
              placeholder="请输入搜索关键字"
              @focus="$router.push(SearchCenter)"
            />
            <img src="../assets/搜索.png" alt="" />
          </div>
        </div>
        <div class="x-city__banner">
          <van-swipe :autoplay="3000">
            <van-swipe-item v-for="(s, i) in topBanner.list" :key="i">
              <a :href="s.url">
                <img :src="s.src" />
              </a>
            </van-swipe-item>
          </van-swipe>
          <img class="banner-shadow" src="../assets/shadow.png" alt="" />
        </div>
        <div class="x-menu home-menu">
          <!-- <div v-for="(menu, i) in menuList"
               :key="i"
               class="x-menu__item"
               @touchend.stop="menuRouter(menu.link)">
            <img :src="menu.icon"
                 :alt="menu.name">
            <span>{{menu.name}}</span>
          </div> -->
          <template
            v-for="(menu, i) in isApp ? menuList.slice(0, 4) : menuList"
          >
            <template v-if="menu.name === '充值'">
              <div class="x-menu__item" :key="i" @click.stop="toPay">
                <img :src="menu.icon" :alt="menu.name" />
                <span>{{ menu.name }}</span>
              </div>
            </template>
            <template v-else>
              <router-link
                tag="div"
                :to="{ name: menu.route }"
                class="x-menu__item"
                :key="i"
              >
                <img :src="menu.icon" :alt="menu.name" />
                <span>{{ menu.name }}</span>
              </router-link>
            </template>
          </template>
        </div>
        <section class="x-city__part hr-top">
          <div class="x-part__title">{{ book[0].name }}</div>
          <div class="x-part__books">
            <div class="x-part__books--cover">
              <x-book
                :book="v"
                width="1.5rem"
                v-for="(v, i) in book[0].list.slice(0, 4)"
                :key="i"
              ></x-book>
            </div>
            <div class="x-part__books--text">
              <template v-for="(v, i) in book[0].list">
                <x-book
                  class="x-part__books--nocover"
                  :book="v"
                  hide-cover
                  :key="i"
                  v-if="i > 3"
                ></x-book>
              </template>
            </div>
          </div>
        </section>
        <section class="x-city__part hr-top">
          <van-tabs
            class="x-city__swiper"
            v-model="curSwiper"
            :line-width="30"
            swipeable
            animated
            @change="changeCurSwiper"
          >
            <van-tab v-for="(item, i) in swipers" :key="i" :title="item.name">
              <div class="x-city__swiper--item">
                <x-book
                  :book="v"
                  hide-cover
                  v-for="(v, index) in swiperBook.list"
                  :key="index"
                ></x-book>
              </div>
            </van-tab>
          </van-tabs>
        </section>
        <section class="x-city__part x-monthly">
          <van-swipe :autoplay="3000">
            <van-swipe-item v-for="(s, i) in monthBag.list" :key="i">
              <a :href="s.url">
                <img :src="s.src" />
              </a>
            </van-swipe-item>
          </van-swipe>
        </section>
        <section class="x-city__part">
          <div class="x-part__title">{{ book[4].name }}</div>
          <div class="x-part__books">
            <div class="x-part__books--swiper">
              <van-swipe :autoplay="3000">
                <van-swipe-item
                  v-for="(b, i) in book[4].list.slice(0, 4)"
                  :key="i"
                >
                  <x-book :book="b" width="1.6rem" multi>
                    <p class="book-name">{{ b.name }}</p>
                    <p class="book-author">作者：{{ b.author }}</p>
                    <p class="book-intro" v-html="b.intro"></p>
                  </x-book>
                </van-swipe-item>
              </van-swipe>
            </div>
            <div class="x-part__books--text">
              <template v-for="(v, i) in book[4].list">
                <x-book
                  class="x-part__books--nocover"
                  :book="v"
                  hide-cover
                  :key="i"
                  v-if="i > 3"
                ></x-book>
              </template>
            </div>
          </div>
        </section>
        <section class="x-city__part hr-top">
          <div class="x-part__title">{{ book[5].name }}</div>
          <div class="x-part__books">
            <div class="x-part__books--swiper">
              <van-swipe :autoplay="3000">
                <van-swipe-item
                  v-for="(b, i) in book[5].list.slice(0, 4)"
                  :key="i"
                >
                  <x-book :book="b" width="1.6rem" multi>
                    <p class="book-name">{{ b.name }}</p>
                    <p class="book-author">作者：{{ b.author }}</p>
                    <p class="book-intro" v-html="b.intro"></p>
                  </x-book>
                </van-swipe-item>
              </van-swipe>
            </div>
            <div class="x-part__books--text">
              <template v-for="(v, i) in book[5].list">
                <x-book
                  class="x-part__books--nocover"
                  :book="v"
                  hide-cover
                  :key="i"
                  v-if="i > 3"
                ></x-book>
              </template>
            </div>
          </div>
        </section>
        <section class="x-city__part hr-top">
          <div class="x-part__title">{{ book[6].name }}</div>
          <div class="x-part__books">
            <div class="x-part__books--cover">
              <x-book
                :book="v"
                width="1.5rem"
                v-for="(v, i) in book[6].list.slice(0, 4)"
                :key="i"
              ></x-book>
            </div>
            <div class="x-part__books--text">
              <template v-for="(v, i) in book[6].list">
                <x-book
                  class="x-part__books--nocover"
                  :book="v"
                  hide-cover
                  :key="i"
                  v-if="i > 3"
                ></x-book>
              </template>
            </div>
          </div>
        </section>
        <x-footer />
      </div>
      <van-popup
        v-model="show"
        position="bottom"
        :overlay="false"
        class="popup"
      >
        <div class="bottom-teenage">
          <img src="../assets/bottom-teenage.png" alt="" />
        </div>
        <div class="qing-message">
          为呵护未成年人健康发展，原创书殿特别推出青少年模式，该模式下部分功能无法正常使用。
          请监护人主动选择，并设置监护密码。
        </div>
        <div @click="gotoTeenagers" class="qing-enter">进入青少年模式 ></div>
        <van-button type="danger" @click="colseTeenagePoup" class="qing-btn">
          我知道了</van-button
        >
      </van-popup>
    </template>
  </div>
</template>

<script>
import {
  SearchCenter,
  Stock,
  Library,
  BookRank,
  Pay,
  PersonalCenter,
} from "./index.js";
import { getHome } from "@/api";
import { mapState } from "vuex";
import { switchRecharge } from "@/utils/app_register";
export default {
  name: "home",
  data() {
    return {
      isLogin: true,
      show: false,
      book: [],
      swiperBook: [],
      init: false,
      curSwiper: 0,
      SearchCenter: SearchCenter.name,
      swipers: [
        {
          type: "free",
          name: "免费阅读",
        },
        {
          type: "newBook",
          name: "新书上架",
        },
        {
          type: "endBook",
          name: "人气完本",
        },
      ],
      topBanner: [],
      monthBag: [],
      banners: [],
      menuList: [
        {
          name: "最近阅读",
          icon: "https://cdn.ycsd.cn/ycsd_web_3nd/images/recent.png",
          route: Stock.name,
          link: "/stock",
        },
        {
          name: "书库",
          icon: "https://cdn.ycsd.cn/ycsd_web_3nd/images/library.png",
          route: Library.name,
          link: "/library",
        },
        {
          name: "排行榜",
          icon: "https://cdn.ycsd.cn/ycsd_web_3nd/images/rank.png",
          route: BookRank.name,
          link: "/rank",
        },
        {
          name: "充值",
          icon: "https://cdn.ycsd.cn/ycsd_web_3nd/images/pay.png",
          route: Pay.name,
          link: "/recharge",
        },
        {
          name: "个人中心",
          icon: "https://cdn.ycsd.cn/ycsd_web_3nd/images/user.png",
          route: PersonalCenter.name,
          link: "/personalcenter",
        },
      ],
      loading: false,
    };
  },
  computed: {
    ...mapState("system", ["isApp"]),
  },
  created() {
    getHome()
      .then((r) => {
        if (r.is_popup == 1) {
          this.show = true;
        } else {
          this.show = false;
        }
        this.book = r.books;
        this.banners = r.banners;
        this.topBanner = this.getBannerBySBStruct("首页banner");
        this.monthBag = this.getBannerBySBStruct("包月banner");
        this.swiperBook = r.books[1];
        this.gettype(r.books);
        this.init = true;
      })
      .catch((e) => {
        console.log(e);
      });
  },
  methods: {
    changeCurSwiper(index, title) {
      let bookindex;
      index === 0
        ? (bookindex = 1)
        : index === 1
        ? (bookindex = 2)
        : (bookindex = 3);
      this.swiperBook = this.book[bookindex];
    },
    colseTeenagePoup() {
      this.show = false;
    },
    gotoTeenagers() {
      if (this.isLogin) {
        this.$router.push({
          name: "TeenAgers",
        });
      } else {
        this.$router.push({
          name: "Login",
        });
      }
    },
    gettype(r) {
      // this.swipers[0].type = r[1].code;
      // this.swipers[1].type = r[2].code;
      // this.swipers[2].type = r[3].code;
      this.swipers[0].name = r[1].name;
      this.swipers[1].name = r[2].name;
      this.swipers[2].name = r[3].name;
    },
    menuRouter(link) {
      this.$router.push(link);
    },
    specialClick(book, pzp) {
      // 特殊标志位
      location.href = `/detail/${book.bid}?pzp=${pzp}`;
      // this.$router.push(`/detail/${book.bid}?pzp=${pzp}`);
    },
    getBannerBySBStruct(bannerName) {
      // 很傻比的数据结构只能对应傻逼的处理方式
      return this.banners.filter((b) => b.name === bannerName)[0];
    },
    toPay() {
      if (this.isApp) {
        switchRecharge();
      } else {
        this.$router.push({ name: Pay.name });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.popup {
  height: 5.5rem;
  border-radius: 0.2rem 0.2rem 0px 0px;
  .bottom-teenage {
    margin: 0.24rem auto 0.16rem;
    img {
      width: 1.66rem;
      height: 1.66rem;
    }
  }
  .qing-message {
    text-align: start;
    margin: 0 auto;
    width: 6.62rem;
    height: 1.32rem;
    font-size: 0.3rem;
    color: #666666;
    line-height: 0.44rem;
  }
  .qing-enter {
    height: 0.42rem;
    font-size: 0.32rem;
    color: #e97043;
    line-height: 0.42rem;
    margin: 0 auto;
    margin-top: 0.1rem;
  }
  .qing-btn {
    width: 3.5rem;
    height: 0.8rem;
    background: linear-gradient(90deg, #fe4e0d 0%, #ff925b 100%);
    border-radius: 0.4rem;
    margin-top: 0.1rem;
  }
}
</style>
